export default {
  namespaced: true
}
